import React from "react";
import { NumberedIconCard } from "./NumberedIconCard";
interface props {
  stepNumber: string;
  icon: React.ReactNode;
  title: string;
  details: string;
  className?: string;
}

export const StartBiddingProcessCard = ({
  stepNumber,
  icon,
  title,
  details,
  className,
}: props) => {
  return (
    <div className={`${className}`}>
      <NumberedIconCard stepNumber={stepNumber} icon={icon} />
      <p className="font-openSans font-semibold text-mobile-body-lg lg:text-web-subheading leading-[22px] lg:leading-6 text-brand-textBlack mt-4 lg:mt-[55px]">
        {title}
      </p>
      <p className="font-openSans font-normal text-mobile-body-md lg:text-web-body-lg leading-6 text-brand-textLightGrey mt-[14px] lg:mt-[21px]">
        {details}
      </p>
    </div>
  );
};
